import { combineReducers } from 'redux-immutable';
import inEditMode          from './inEditMode';
import registeredContent   from './registeredContent';


export default combineReducers({inEditMode, registeredContent});



// WEBPACK FOOTER //
// ./src/modules/editableContent/reducers/index.js